import { Copy, KeyRound } from "lucide-react";
import ItemIcon from "./ItemIcon";
import ItemMenu from "./ItemMenu";
import ItemText from "./ItemText";
import { CopyTooltip } from "./CopyTooltip";

const ChaveButton = ({ chave_empreender, copiarChave }: { chave_empreender: string; copiarChave: () => void }) => {
    return (
        <CopyTooltip
            className='w-full [&>div:first-of-type]:w-full'
            onCopyClick={() => {
            copiarChave();
        }}
        >
            <ItemMenu className='!gap-2 !px-2 py-2.5 group/chave' preventDefault onClick={copiarChave}>
                <ItemIcon>
                    <KeyRound />
                </ItemIcon>
                <ItemText skipSidebar className='flex items-center justify-between w-full [&_svg]:!size-4'>{chave_empreender} <span className='text-gray-500 opacity-0 group-hover/chave:opacity-100'><Copy /></span></ItemText>
            </ItemMenu>
        </CopyTooltip>
    )
};

export default ChaveButton